import { setPricePlans, setPrices } from "store/actions/productAction";
import {
  apiAddPricePlan, apiChangePriceListSpeed, apiDeletePricePlans,
  apiGetPricePlans,
  apiProductPriceList, apiSetProductPriceList,
  apiUpdatePricePlan
} from "api/productApi";
import Price from "components/Table2/CellComps/Price";
import Text from "components/Table2/CellComps/Text";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ChangePricesState } from "./modals/Change";
import shortid from "shortid";
import { appSetAlert } from "store/actions/appAction";

const defaultPricePlans: Plan[] = [
  { title: "قیمت فروش", key: "sellPrice", id: "sellPrice", ind: shortid.generate(), code: "" },
  { title: "قیمت خرید", key: "buyPrice", id: "buyPrice", ind: shortid.generate(), code: "" },
];

interface FD {
  pagination: { page: number; perPage: number };
  selectedItems?: any[];
  activeTab: number;
}

const initialFd = {
  pagination: { page: 1, perPage: 10 },
  selectedItems: [],
  activeTab: 0,
};

export default function useUpdatePrice() {
  const dispatch: any = useDispatch();
  const store = useSelector((x: any) => x);
  const token = store?.businessReducer?.business?.token;
  const products: any[] = store?.productReducer?.products || [];
  const pricePlans: Plan[] = store?.productReducer?.pricePlans || [];
  const plans: Plan[] = [...defaultPricePlans, ...pricePlans];
  const prices: Price[] = store?.productReducer?.prices || [];
  const [fd, setFd] = useState<FD>(initialFd);
  const [count, setCount] = useState(0);
  const { pagination } = fd;
  const [Products, setProducts] = useState<any[]>(products);
  const [rows, setRows] = useState<any[]>(products);
  useEffect(() => {
    dispatch(
      apiProductPriceList(token, (res: any) => {
        setRows(res.products);
        setProducts(res.products);
        // if (!prices || prices.length === 0) dispatch(setPrices(res.prices));
        // dispatch(setPrices([]));
      })
    );

    dispatch(apiGetPricePlans(token));
  }, [token]);

  const reRender = () => setCount((x) => x + 1);

  function handleTabChange(tabNumber?: number) {
    if (tabNumber === undefined) return;
    const tabsRows = [
      Products,
      Products.filter((x: any) => x.isProduct),
      Products.filter((x: any) => !x.isProduct),
    ];
    const newRows = tabsRows[tabNumber];
    if (newRows !== undefined) {
      setFd((x) => ({ ...x, activeTab: tabNumber }));
      setRows(newRows);
      setFd((x) => ({ ...x, pagination: { ...x.pagination, page: 1 } }));
      reRender();
    }
  }

  async function addPlan(plan: Plan) {
    const exist = plan.id && pricePlans.findIndex((x) => x.id === plan.id) >= 0;
    if (exist) await editPlan(plan);
    else {
      await dispatch(
        apiAddPricePlan({
          token,
          data: {
            title: plan.title,
            code: plan.code,
            currencyId: plan?.currency?.id,
            round: true,
            decimal: 2,
            round_type: "down",
            status: true,
            ...plan.dependOn
          },
          cb: (res: any) => {
            const id = res.data?.priceplan?.id;
            if (id && plan.dependOn) {
              savePricesByProducts({ ...plan, id }, Products);
            }

            dispatch(apiGetPricePlans(token));
          },
        })
      );
    }
  }

  function editPlan(plan: Plan) {
    return new Promise(() => {
      dispatch(
        apiUpdatePricePlan({
          token,
          data: {
            title: plan.title,
            code: plan.code,
            currencyId: plan?.currency?.id,
            round: true,
            decimal: 2,
            round_type: "down",
            status: true,
          },
          params: { id: plan.id },
          cb: (res: any) => {
            dispatch(apiGetPricePlans(token));
          },
        })
      );
    });
  }

  function deletePlan(plan: Plan) {
    dispatch(
      apiDeletePricePlans({
        token,
        data: { pricePlansIds: [plan.id] },
        cb: () => {
          dispatch(setPricePlans(pricePlans.filter((x) => x.id !== plan.id)));
          dispatch(setPrices(prices.filter((x) => x.PricePlanId !== plan.id)));
        },
      })
    );
  }

  function changePrices(props: ChangePricesState, fromSpeedModal?: boolean) {
    const { plan, amount, dir, round, roundAcc, roundDir, type } = props;
    if (!plan) return;
    if (fromSpeedModal) {
    return  dispatch(apiChangePriceListSpeed(plan?.id, { changeType: dir === "inc" ? "increase" : 'decrease', changeValue: amount, changeValueType: type },(res:any)=>{

      }))
    }
    let newPrices = [...prices];

    for (const product of products) {
      let price = 0;
      const index = newPrices.findIndex((x) => x.ProductId === product.id && x.PricePlanId === plan.id);
      if (index >= 0) price = newPrices[index].price;

      const checkedItems = fd.selectedItems;
      const allowChange = !checkedItems || checkedItems.length === 0 || checkedItems.includes(product.id);

      if (amount && dir && type && allowChange) {
        let num = amount;
        if (type === "percent") {
          num = (num / 100) * price;
        }
        if (dir === "inc") price = price + num;
        if (dir === "dec") price = price - num;
        if (round && roundAcc && roundDir) {
          const rnd = roundDir === "down" ? Math.floor : Math.ceil;
          const dec = 10 ^ roundAcc;
          price = rnd(price * dec) / dec;
        }
        const res = { ProductId: product.id, PricePlanId: plan.id, price, edited: true };
        if (index >= 0) newPrices[index] = res;
        else newPrices.push(res);
      }
    }

    dispatch(setPrices(newPrices));
    reRender();
  }

  function savePrices() {

    const data = {
      priceList: prices
        .filter((x) => {
          const checkedItems = fd.selectedItems;
          const allowChange =
            !checkedItems || checkedItems.length === 0 || checkedItems.includes(x.ProductId);
          return x.price >= 0 && allowChange && x.edited;
        })
        .map((price) => {
          return {
            productId: price.ProductId,
            pricePlanId: price.PricePlanId,
            price: price.price,
          };
        }),
    };
    if (data.priceList.length === 0) {
      dispatch(appSetAlert("قیمت ها به روز هستند", "success"));
      return;
    }
    dispatch(
      apiSetProductPriceList(token, data, () => {
        dispatch(setPrices(prices.map((x) => ({ ...x, edited: false }))));
      })
    );
  }

  function savePricesByProducts(plan: Plan, products: any[]) {
    const dependOn = plan.dependOn;
    if (!dependOn) return;
    const data = {
      secondPricePlanId: dependOn.secondPricePlanId,
      secondPricePlanPercent: dependOn.secondPricePlanPercent
      // priceList: products.flatMap((p: any) => {
      //   let price = prices.find((x) => x.ProductId === p.id && x.PricePlanId === dependOn.secondPricePlanId)?.price;
      //   if (!price) return [];
      //   price = (dependOn.secondPricePlanPercent / 100) * price;
      //   return {
      //     productId: p.id,
      //     pricePlanId: plan.id,
      //     price,
      //   };
      // }),
    };

    dispatch(
      apiSetProductPriceList(token, data, (res: any) => {
        console.log(res.data)
        const newPrices = [
          ...prices,
          // ...data.priceList.map((x: any) => ({
          //   ProductId: x.productId,
          //   PricePlanId: x.pricePlanId,
          //   price: x.price,
          //   edited: true,
          // })),
        ];
        dispatch(setPrices(newPrices));
        reRender();
      })
    );
  }

  const table: TableProps = {
    headers: [
      { label: "کد" },
      { label: "کالا" },
      ...plans.map((x) => ({ label: x.title, style: { minWidth: 150, width: 150 } })),
    ],
    cols: [
      { Comp: Text, key: "id" },
      { Comp: Text, key: "label" },
      ...plans.map((plan, i) => {
        return {
          Comp: Price,
          key: plan.title,
          getValue: (item: any) => {
            const price = prices.find((x) => x.ProductId === item.id && x.PricePlanId === plan.id);
            if (price) return price.price;
            else return undefined;
          },
          options: {
            editable: true,
            onChange: (item: any) => {
              let newPrices = [...prices];
              const index = newPrices.findIndex((y) => y.ProductId === item.id && y.PricePlanId === plan.id);
              const price = {
                ProductId: item.id,
                price: item[plan.title],
                PricePlanId: plan.id,
                edited: true,
              };
              if (index >= 0) newPrices[index] = price;
              else newPrices.push(price);
              dispatch(setPrices(newPrices));
            },
          },
        };
      }),
    ],
    rows,
    tabs: {
      tabs: [{ label: "همه" }, { label: "کالا" }, { label: "خدمات" }],
      onChange: handleTabChange,
      activeTab: fd.activeTab,
    },
    pagination: {
      ...pagination,
      onChange: ({ page, perPage }) =>
        setFd((x) => ({ ...x, pagination: { ...x.pagination, page, perPage } })),
    },
    withCheckBox: true,
    checkbox: {
      key: "id",
      items: fd.selectedItems || [],
      onChange: (items) => setFd((x) => ({ ...x, selectedItems: items })),
    },
    count,
    headerColor: "#ffffff",
    withSort: true,
    withSearch: true,
  };

  return { table, count, pricePlans, plans, addPlan, editPlan, deletePlan, changePrices, savePrices };
}
